import { BaseSopOperation } from "./_Base";
import { MathUtils, PerspectiveCamera, Vector3 } from "three";
import { InputCloneMode } from "../../../engine/poly/InputCloneMode";
import { CameraNodeType } from "../../poly/NodeContext";
import { PERSPECTIVE_CAMERA_DEFAULT, registerPerspectiveCamera } from "../../../core/camera/CorePerspectiveCamera";
import { CORE_CAMERA_DEFAULT, PerspectiveCameraAttribute } from "../../../core/camera/CoreCamera";
import { isBooleanTrue } from "../../../core/Type";
import { CameraHelper } from "../../../core/helpers/CameraHelper";
import { CoreObject } from "../../../core/geometry/Object";
const _PerspectiveCameraSopOperation = class extends BaseSopOperation {
  static type() {
    return CameraNodeType.PERSPECTIVE;
  }
  cook(inputCoreGroups, params) {
    const camera = new PerspectiveCamera(params.fov, 1, params.near, params.far);
    camera.name = CameraNodeType.PERSPECTIVE;
    camera.position.copy(params.position);
    camera.rotation.set(MathUtils.degToRad(params.rotation.x), MathUtils.degToRad(params.rotation.y), MathUtils.degToRad(params.rotation.z));
    camera.updateMatrix();
    camera.updateProjectionMatrix();
    camera.matrixAutoUpdate = params.matrixAutoUpdate;
    _PerspectiveCameraSopOperation.setCameraAttributes(camera, params);
    const objects = [camera];
    if (isBooleanTrue(params.showHelper)) {
      const helper = new CameraHelper(camera);
      helper.update();
      camera.add(helper);
    }
    return this.createCoreGroupFromObjects(objects);
  }
  static setCameraAttributes(camera, options) {
    CoreObject.addAttribute(camera, PerspectiveCameraAttribute.FOV, options.fov);
  }
};
export let PerspectiveCameraSopOperation = _PerspectiveCameraSopOperation;
PerspectiveCameraSopOperation.DEFAULT_PARAMS = {
  fov: PERSPECTIVE_CAMERA_DEFAULT.fov,
  near: CORE_CAMERA_DEFAULT.near,
  far: CORE_CAMERA_DEFAULT.far,
  position: new Vector3(0, 0, 0),
  rotation: new Vector3(0, 0, 0),
  showHelper: false,
  matrixAutoUpdate: true
};
PerspectiveCameraSopOperation.INPUT_CLONED_STATE = InputCloneMode.NEVER;
PerspectiveCameraSopOperation.onRegister = registerPerspectiveCamera;
